import { Box, styled, useTheme } from "@material-ui/core";
import { graphql } from "gatsby";
import React from "react";
import { SPACING_AROUND, SPACING_AROUND_MOBILE } from "../card/constants";
import BaseCard from "../card/index";
import { getMobileBreakpointUp } from "../card/utils";

const Card = styled(BaseCard)({
  marginBottom: 0,
  height: "fit-content"
});

type Props = Queries.CardGridFragmentFragment & {
  index?: number;
  className?: string;
};

const CardGrid: React.FunctionComponent<Props> = props => {
  const theme = useTheme();
  const mobileBreakpointUp = getMobileBreakpointUp();

  return (
    <Box
      key={`card-grid-${props.columns}-${props.columnsTablet}-${props.columnsMobile}`}
      display="grid"
      gridGap={{
        xs: `${theme.spacing(SPACING_AROUND_MOBILE)}px`,
        [mobileBreakpointUp]: `${theme.spacing(SPACING_AROUND)}px`
      }}
      gridTemplateColumns={{
        xs: `repeat(${props.columnsMobile || props.columns}, 1fr)`,
        sm: `repeat(${props.columnsTablet || props.columns}, 1fr)`,
        md: `repeat(${props.columns}, 1fr)`
      }}
    >
      {props.cards.map(card => (
        <Card
          key={`card-${card.slug}-${card.aspectRatio}-${card.aspectRatioMobile}`}
          index={props.index}
          {...card}
        />
      ))}
    </Box>
  );
};

export const CardGridFragment = graphql`
  fragment CardGridFragment on DatoCmsCModuleCardGrid {
    slug
    cards {
      ...CardFragment
    }
    columns
    columnsTablet
    columnsMobile
    visibilitySettings {
      ...ContentModuleVisibilitySettingFragment
    }
    container
    innerContainer
    containerDisableGutters
    containerBackgroundColor
    model {
      apiKey
    }
  }
`;

export default React.memo(CardGrid);
